import React from 'react'
import { FileStatus, getFileStatus, getStatusEmoji } from 'domain/FileStatus'
import { FileType, InstallationAssortmentStatus } from 'domain/DTO'

type Props = {
  assortmentStatuses: {
    type: FileType
    status: InstallationAssortmentStatus
  }[]
}

export const AssortmentStatusCell = ({ assortmentStatuses }: Props) => {
  const fileStatuses = assortmentStatuses.map(({ type, status }) => getFileStatus(status, type))

  return <div className="flex flex-col">{fileStatuses.map(renderFileStatus)}</div>
}

function renderFileStatus(fileStatus: FileStatus) {
  const icon = getStatusEmoji(fileStatus.uiStatus)
  return <div key={fileStatus.type} title={fileStatus.cause}>{`${icon} ${fileStatus.type}`}</div>
}
